import { useEffect, useState } from 'react';
import { getTrackedEmailWithBreaches } from '../../lib/use-cases/get-tracked-email-with-breaches';
import { toggleBreachResolution } from '../../lib/use-cases/toggle-breach-resolution';

function useTrackedEmailWithBreaches(id) {
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isFail, setIsFail] = useState(false);

    const getData = async (id) => {
        try {
            const response = await getTrackedEmailWithBreaches(id);

            setData(response);
        } catch (e) {
            setIsFail(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggleBreachResolution = async (breachId, isResolved) => {
        try {
            toggleBreachResolution(breachId, {isResolved});

            setData(prevState => ({
                ...prevState,
                resolvedBreaches: isResolved ? prevState.resolvedBreaches + 1 : prevState.resolvedBreaches - 1,
                breaches: prevState.breaches.map(breach => breach.id === breachId ? {...breach, isResolved} : breach)
            }));
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getData(id);
    }, [id]);

    return {
        data,
        isLoading,
        isFail,
        toggleBreachResolution: handleToggleBreachResolution
    }
};

export {
    useTrackedEmailWithBreaches
};
